@layer refine.base {
  :host {
    --_width: var(--switch-width, var(--size-10));
    --_height: var(--switch-height, var(--size-5));
    --_padding: var(--size-0-5);
    --_thumb-size: calc(var(--_height) - var(--_padding) * 2);
    --_track-bg: var(--switch-track-bg, var(--color-contrast-300));
    --_thumb-bg: var(--switch-thumb-bg, white);
    --_font-size: var(--switch-font-size, var(--text-sm));

    display: inline-flex;
    flex-wrap: wrap;
    gap: var(--_gap, var(--size-2-5));
    align-items: center;
    min-height: var(--_touch-target);
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
  }

  /* ========================================
       Track & Thumb
       ======================================== */

  .switch-wrapper {
    display: flex;
    flex-shrink: 0;
  }

  .switch-track {
    position: relative;
    width: var(--_width);
    height: var(--_height);
    background: var(--_track-bg);
    border-radius: var(--rounded-full);
    transition:
      background var(--transition-normal),
      box-shadow var(--transition-normal);
  }

  .switch-thumb {
    position: absolute;
    inset-inline-start: var(--_padding);
    top: var(--_padding);
    width: var(--_thumb-size);
    height: var(--_thumb-size);
    background: var(--_thumb-bg);
    border-radius: var(--rounded-full);
    box-shadow: var(--shadow-sm);
    transition:
      transform var(--transition-spring),
      box-shadow var(--transition-normal);
    will-change: transform;
  }

  /* ========================================
       Focus State
       ======================================== */

  :host(:focus-visible) .switch-track {
    box-shadow: var(--_focus-shadow);
  }

  /* ========================================
       Label
       ======================================== */

  .label {
    font-size: var(--_font-size);
    color: var(--color-contrast);
  }
}

@layer refine.overrides {
  /* Map theme variables to switch-specific variables */
  :host {
    --_active-bg: var(--switch-checked-bg, var(--_theme-base));
    --_focus-shadow: var(--_theme-shadow);
  }

  /* ========================================
       Checked State
       ======================================== */

  :host([checked]) .switch-track {
    background: var(--_active-bg);
  }

  :host([checked]) .switch-thumb {
    transform: translateX(calc(var(--_width) - var(--_height)));
  }

  /* In RTL the thumb starts at the inline-end edge; slide left to reach inline-start */
  :host(:dir(rtl)[checked]) .switch-thumb {
    transform: translateX(calc(-1 * (var(--_width) - var(--_height))));
  }

  /* ========================================
       Hover & Active States
       ======================================== */

  :host(:hover:not([disabled], [checked])) .switch-track {
    background: var(--color-contrast-400);
  }

  :host(:hover:not([disabled])[checked]) .switch-track {
    filter: brightness(1.1);
  }

  /* ========================================
       Helper / Error Text
       ======================================== */

  .helper-text[hidden] {
    display: none;
  }

  .helper-text {
    width: 100%;
    padding-inline-start: calc(var(--_width) + var(--size-2-5));
    font-size: var(--text-xs);
    line-height: var(--leading-tight);
    color: color-mix(in oklch, var(--color-contrast-500) 80%, var(--color-canvas));
  }

  .helper-text[role='alert'] {
    color: var(--color-error);
  }
}
